<template>
    <section
        v-show="state.processing === false"
        class="body"
        aria-live="polite"
        aria-atomic="true"
    >
        <error 
            v-if="currentPaymentOption == 'banktransfer' && state.error == 'TIMED_OUT'"
            :error="null" 
            :method="state.method"
        />
        <template v-else>
            <error v-if="!cardError && !momoError && !banktransferError" :error="state.error" :method="state.method" :paymentOptions="state.paymentMethods" />
            <error v-if="cardError" :method="state.method" :cardError="cardError && currentPaymentOption == 'card' ? cardError: '' " />
            <error 
                v-if="momoError" 
                :method="state.method" 
                :momoError="momoError && 
                    currentPaymentOption.includes('mobilemoney') || currentPaymentOption == 'mpesa' ? momoError : '' "
            />
            <error v-if="banktransferError" :method="state.method" :banktransferError="banktransferError && currentPaymentOption == 'banktransfer' ? banktransferError: '' " />
        </template>

        <promo-view 
            v-if="state.campaignInfo && 
                (state.currentView.includes('INIT_VIEW') || state.currentView.includes('CODE_VIEW') || state.currentView.includes('REDIRECT_VIEW') || state.currentView.includes('DETAILS_VIEW'))"
            :campaign-info="state.campaignInfo" 
            :currency="state.currency"
        />

        <FawryInfo v-if="currentPaymentOption === 'fawrypay' && state.currentView === 'FAWRYPAY_INIT_VIEW'" />

        <BankInfo v-if="currentPaymentOption === 'account' && !['ZAR', 'NGN', 'USD'].includes(state.currency)" />

        <MomoGHSLevyNotice v-if="currentPaymentOption === 'mobilemoneyghana'" />

        <template v-if="(state?.dccInfo?.to == 'NGN' || state?.dccInfo?.to == 'ZAR')">
            <!-- TODO: re-check implementation with dcc -->
            <!-- TODO: hide this when user is using dcc select currency -->
            <div class="dcc__info">
                <dcc-info 
                    v-if="state.method === 'card' && state?.dccInfo" 
                    :dccInfo="state?.dccInfo" 
                    :campaignInfo="state?.campaignInfo"
                    :amount="state.amount"
                />
            </div>
        </template>
        
        <transition name="fade">
            <!-- <pay-with-plaid/> -->
            <card-payment 
                v-if="currentPaymentOption == 'card'"
                @error-message="setCardError" 
            />
            <applepay v-else-if="currentPaymentOption == 'applepay'" />
            <capitec v-else-if="currentPaymentOption == 'capitec'" />
            <fawrypay v-else-if="currentPaymentOption == 'fawrypay'" />
            <bank-payment v-else-if="currentPaymentOption == 'account'" />
            <googlepay v-else-if="currentPaymentOption == 'googlepay'" />
            <eNaira v-else-if="currentPaymentOption == 'enaira'" />
            <ussd-payment v-else-if="currentPaymentOption === 'ussd'" />
            <qr-payment v-else-if="currentPaymentOption === 'qr'" />
            <paga-payment v-else-if="currentPaymentOption === 'paga'" />
            <pay-with-migo v-else-if="currentPaymentOption === 'migo'" />
            <nqr-payment v-else-if="currentPaymentOption === 'nqr'" />
            <voucher v-else-if="currentPaymentOption === '1voucher'" />
            <mpesa v-else-if="currentPaymentOption === 'mpesa'" @momo-error="setMomoError" />
            <internet-banking
                v-else-if="currentPaymentOption === 'internetbanking'"
            />
            <mobile-money-ghana
                v-else-if="currentPaymentOption === 'mobilemoneyghana'"
                @momo-error="setMomoError"
            />
            <mobile-money-franco
                v-else-if="currentPaymentOption === 'mobilemoneyfranco'"
                @momo-error="setMomoError"
            />
            <mobile-money-uganda
                v-else-if="currentPaymentOption === 'mobilemoneyuganda'"
                @momo-error="setMomoError"
            />
            <mobile-money-rwanda
                v-else-if="currentPaymentOption === 'mobilemoneyrwanda'"
                @momo-error="setMomoError"
            />
            <mobile-money-zambia
                v-else-if="currentPaymentOption === 'mobilemoneyzambia'"
                @momo-error="setMomoError"
            />
            <mobile-money-tanzania
                v-else-if="currentPaymentOption === 'mobilemoneytanzania'"
                @momo-error="setMomoError"
            />
            <mobile-money-malawi
                v-else-if="currentPaymentOption === 'mobilemoneymalawi'"
                @momo-error="setMomoError"
            />
            <opay 
                v-else-if="currentPaymentOption === 'opay'" 
            />
            <bank-transfer 
                v-else-if="currentPaymentOption === 'banktransfer'"
                @error-message="setBanktransferError" />
            <pay-attitude v-else-if="currentPaymentOption === 'payattitude'" />
            <cryptocurrency v-else-if="currentPaymentOption === 'cryptocurrency'" />
            <wechat v-else-if="currentPaymentOption === 'wechat'" />
            <paypal v-else-if="currentPaymentOption === 'paypal'" />
        </transition>
    </section>
</template>
<script>
import { ref, onBeforeUnmount, watch } from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath } from "@/support/helpers";

import CardPayment from "@/components/payment-options/card-payment";
import BankPayment from "@/components/payment-options/bank-payment";
import UssdPayment from "@/components/payment-options/ussd-payment";
import InternetBanking from "@/components/payment-options/internet-banking";
import QrPayment from "@/components/payment-options/qr-payment";
import PagaPayment from "@/components/payment-options/paga-payment";
import PayWithMigo from "@/components/payment-options/pay-with-migo";
// import PayWithPlaid from "@/components/payment-options/plaid-payment";
import Voucher from "@/components/payment-options/voucher";

import Mpesa from "@/components/payment-options/mpesa";
import MobileMoneyGhana from "@/components/payment-options/mobile-money-ghana";

import MobileMoneyUganda from "@/components/payment-options/mobile-money-uganda";

import MobileMoneyRwanda from "@/components/payment-options/mobile-money-rwanda";

import MobileMoneyZambia from "@/components/payment-options/mobile-money-zambia";

import MobileMoneyMalawi from "@/components/payment-options/mobile-money-malawi";

import MobileMoneyTanzania from "@/components/payment-options/mobile-money-tanzania";
import MobileMoneyFranco from "@/components/payment-options/mobile-money-franco";
import NqrPayment from "@/components/payment-options/nqr-payment";
import BankTransfer from "@/components/payment-options/bank-transfer";

import PayAttitude from "@/components/payment-options/payattitude";
import Cryptocurrency from "@/components/payment-options/cryptocurrency";

import Paypal from "@/components/payment-options/paypal-payment";
import Wechat from "@/components/payment-options/wechat";
import Error from "@/components/common/payment-error";
import ENaira from "@/components/payment-options/eNaira";
import Applepay from "@/components/payment-options/applepay.vue";
import Googlepay from "@/components/payment-options/googlepay.vue";
import Opay from "@/components/payment-options/opay.vue";
import FawryInfo from "@/components/fawry-info.vue";
import Fawrypay from "@/components/payment-options/fawrypay.vue";
import PromoView from "@/components/common/promo-view.vue";
import BankInfo from "@/components/bank-info.vue";
import MomoGHSLevyNotice from "@/components/momo-ghs-levy-info.vue";
import Capitec from "@/components/payment-options/capitec.vue";

import DccInfo from "@/components/common/dcc-info.vue";

import { useI18n } from "vue-i18n";

export default {
    name: "PaymentBody",
    components: {
        BankPayment,
        BankTransfer,
        CardPayment,
        Cryptocurrency,
        Error,
        InternetBanking,
        MobileMoneyGhana,
        MobileMoneyFranco,
        MobileMoneyUganda,
        MobileMoneyRwanda,
        MobileMoneyZambia,
        MobileMoneyTanzania,
        MobileMoneyMalawi,
        Mpesa,
        NqrPayment,
        PagaPayment,
        PayAttitude,
        Paypal,
        PayWithMigo,
        // PayWithPlaid,
        QrPayment,
        UssdPayment,
        Voucher,
        Wechat,
        ENaira,
        Applepay,
        Googlepay,
        Opay,
        DccInfo,
        FawryInfo,
        Fawrypay,
        PromoView,
        BankInfo,
        MomoGHSLevyNotice,
        Capitec,
    },
    props: {
        currentPaymentOption: {
            type: String,
            required: true,
        },
    },
    data: function() {
        return {};
    },

    setup() {
        const { t } = useI18n();
        const store = injectStore();
        const cardError = ref(null);
        const momoError = ref(null);
        const banktransferError = ref(null);
        const checkoutData = ref(store.getState());
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        function setCardError(e){
            if (checkoutData.value.method.current === "card") {
                cardError.value = e;
            }
        }

        function setBanktransferError(e){
            if (checkoutData.value.method.current === "banktransfer") {
                banktransferError.value = e;
            }
        }

        function setMomoError(e) {
            momoError.value = e;
        }

        onBeforeUnmount(() => {
            subscription();
        });

        watch(() => checkoutData.value, (newData) => {
            if (newData) {
                cardError.value = null;
            }
        });

        watch(() => checkoutData.value, (newData) => {
            if (newData && 
                checkoutData.value.error && 
                checkoutData.value.view.current === "ENAIRA_INIT_VIEW") {
                checkoutData.value.error = null;
            }
        });

        watch(() => checkoutData.value, (newData) => {
            if (newData && newData.error === null &&
                checkoutData.value.error && 
                checkoutData.value.error === t("network.fetch.error")) {
                checkoutData.value.error = null;
            }
        });

        watch(() => checkoutData.value, (newData) => {
            if (newData && newData.error === null &&
                checkoutData.value.error && 
                checkoutData.value.error === t("mm.invalid.phonenumber")) {
                checkoutData.value.error = null;
            }
        });

        return {
            state: mapState({
                amount: (state) => getValueFromPath(state, "amount") || null,
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
                method: (state) => getValueFromPath(state, "method.current") || null,
                error: (state) => getValueFromPath(state, "error") || null,
                dccInfo: (state) => getValueFromPath(state, "dcc") || null,
                campaignInfo: (state) => {
                    let campaignObj = getValueFromPath(state, "campaign");
                    if (Object.keys(campaignObj).length > 0) {
                        return campaignObj;
                    }
                    return null;
                },
                processing: (state) => getValueFromPath(state, "processing") || false,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
                paymentMethods: (state) => getValueFromPath(state, "currency.methods") || [],
            }),
            setCardError,
            setMomoError,
            setBanktransferError,
            cardError,
            momoError,
            banktransferError,
        };
    },
};
</script>
<style lang="scss" scoped>
.body {
  margin: 0rem 1rem;
  padding-top: 2.4rem;
  @media screen and (max-width: $breakpoint-middle * 1px) {
    margin: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-bottom: 3rem;
    padding-left: 2.4rem;
    padding-right: 2.4rem;
    overflow: scroll;
  }
}

.fade-enter-active {
  animation: enter 0.4s ease;
}

@keyframes enter {
  0% {
    opacity: 0;
    transform: translateY(-10%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes leave {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>